import EventEmitter from 'events';

import { BaseConnector } from '@particle-network/btc-connectkit';

import { NETWORK } from '../../constants';
import { btcConnectStorage, btcNetworkToBitcoinNetworkType } from '../../utils';

// https://github.com/Particle-Network/particle-btc-connect/blob/6e8ba55fde681a3ebe900a4a0ac0ff13a74003e8/packages/connectkit/src/context/index.tsx#L242
// horrible docs for events, but here is the source code
export enum ParticleEvents {
  AccountsChanged = 'accountsChanged',
}

abstract class ExtendedBaseConnector extends BaseConnector {
  protected eventEmitter = new EventEmitter();
  protected network = btcNetworkToBitcoinNetworkType(NETWORK.Network);
  protected eventListeners: (() => void)[] = [];
  protected btcConnectStorage = btcConnectStorage;

  constructor() {
    super();
    this.eventEmitter.setMaxListeners(100);
  }

  disconnect() {
    sessionStorage.removeItem('current-connector-id');
    this.eventEmitter.emit(ParticleEvents.AccountsChanged, []);
    this.eventListeners.forEach((removeListener) => removeListener());
    this.eventListeners = [];
    this.btcConnectStorage.clearData();
  }
}

export default ExtendedBaseConnector;
